var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSystemDiagonalArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.605 11.605a.749.749 0 1 0 1.497-.036l-.21-8.617 10.403 10.402a.749.749 0 1 0 1.059-1.06L2.952 1.894l8.617.21a.749.749 0 0 0 .036-1.498L1.38.357a.993.993 0 0 0-.62.197.752.752 0 0 0-.205.204.993.993 0 0 0-.197.62l.248 10.227Z",
  fill: "#CDD1D6"
})));
export default SvgIcSystemDiagonalArrow;